import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import CloseIcon from '@mui/icons-material/Close';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { BottomNavigation, BottomNavigationAction, Box, Divider, Drawer, Grid, IconButton, ListItemButton, ListItemIcon, ListItemText, Paper, Tooltip, Typography, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { default as Image, default as Images } from '../../Assets/assetHelper';
import KenAvatar from '../../GlobalComponents/KenAvatar';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import routes from '../../Utils/routes';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import MobileSideNav from './MobileSideNav';
import NotificationDialog from './NotificationDialog';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery('(max-width:1000px)');

  const [hideSideBar, setHideSideBar] = useState(false);
  const [openNotification, setOpenNotification] = React.useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [value, setValue] = useState(0);

  const toggleDrawer = (open: boolean | ((prevState: boolean) => boolean)) => () => {
    setIsDrawerOpen(open);
  };

  const handleOpenClickOpenNotification = () => {
    setOpenNotification(true);
  };

  const handleCloseNotificationDialog = () => {
    setOpenNotification(false);
  };

  const userData = JSON.parse(`${localStorage.getItem('user')}`) as AuthUser;
  const handleListClick = (path: string, index: number) => {
    navigate(path);
  };

  const HandleAccount = () => {
    navigate(routes.profile);
  };

  useEffect(() => {
    setHideSideBar(isMobile);
  }, [isMobile]);

  const handleNavigation = (newValue: number) => {
    setValue(newValue);
    navigate(menuItems[newValue].route);
  };

  const menuItems = [
    { name: 'Events', filledIcon: <AutoAwesomeIcon className={classes.icon} />, outlinedIcon: <AutoAwesomeOutlinedIcon className={classes.icon} />, route: routes.events },
    { name: 'Global Portfolio', filledIcon: <GroupsIcon className={classes.icon} />, outlinedIcon: <GroupsOutlinedIcon className={classes.icon} />, route: routes.startups },
    { name: 'Home', filledIcon: <HomeIcon className={classes.icon} />, outlinedIcon: <HomeOutlinedIcon className={classes.icon} />, route: routes.home },
    { name: 'My Portfolio', filledIcon: <AnalyticsIcon className={classes.icon} />, outlinedIcon: <AnalyticsOutlinedIcon className={classes.icon} />, route: routes.myPortfolio },
    { name: 'People', filledIcon: <AccountCircleIcon className={classes.icon} />, outlinedIcon: <AccountCircleOutlinedIcon className={classes.icon} />, route: routes.people },
  ];

  return (
    <>
      {isMobile ? (
        <>
          <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
            <Box sx={{ p: '16px', pt: '50px', width: '300px', height: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'start',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #F0EDF6',
                  // pb: '32px', my: '32px'
                  height: '130px',
                }}
              >
                <Box>
                  <KenAvatar classes={classes.avatar3} src={userData?.contactImage ? userData?.contactImage : Images.Images.DefaultProfileImage} />
                  <Typography className={classes.menuTitle}>{userData.applicantName}</Typography>
                </Box>
                <Box>
                  <IconButton sx={{ p: '0px' }} onClick={toggleDrawer(false)}>
                    <CloseIcon sx={{ color: '#545454', fontSize: '24px' }} id="main-content" />
                  </IconButton>
                </Box>
              </Box>
              <Box sx={{ height: 'calc(100% - 130px)', width: '100%', minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <Box sx={{ flex: 1, width: '100%', height: '90%', overflow: 'auto' }}>
                  <MobileSideNav handleListClick={handleListClick} />
                </Box>
                <Box sx={{ mb: '0px', width: '100%', borderTop: '1px solid #F0EDF6' }}>
                  <ListItemButton
                    className={classes.menuListItemButton}
                    onClick={() => {
                      dispatch({ type: 'LOGOUT' });
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: { xs: '2px', lg: '40px' } }}>
                      <LogoutIcon className={classes.menuListItemIcon} />
                    </ListItemIcon>

                    <Typography sx={{ pl: '20px' }} className={classes.menuListItemText}>
                      Logout
                    </Typography>
                  </ListItemButton>
                </Box>
              </Box>
            </Box>
          </Drawer>
          <Box sx={{ height: '93vh', overflow: 'hidden', background: '#FFF' }}>
            <Box sx={{ borderBottom: '1px solid #F0EDF6', height: '8%' }}>
              <Box className={classes.header} style={{ boxShadow: 'none' }}>
                <Box className={classes.mobileHeaderContainer}>
                  <IconButton aria-label="menu" onClick={toggleDrawer(true)}>
                    <KenAvatar classes={classes.avatar2} src={userData?.contactImage ? userData?.contactImage : Images.Images.DefaultProfileImage} />{' '}
                  </IconButton>
                  <Box>
                    <AppBreadCrumbs />
                  </Box>
                  <Box sx={{ gap: '10px' }}>
                    <IconButton onClick={() => navigate(routes.notifcation)}>
                      <img src={Images.Icons.notificationIcon} alt="" />
                    </IconButton>
                    <IconButton sx={{ background: '#F0EDF6' }} onClick={() => navigate(routes.chat)}>
                      <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: '16px', color: '#604797' }} />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ background: '#FFF', height: '92%', overflow: 'auto' }}>
              <Box sx={{ m: '10px 16px ' }}>{children}</Box>
            </Box>
          </Box>
          <Box style={{ height: '7vh' }}>
            <BottomNavigation value={value} onChange={(event, newValue) => handleNavigation(newValue)} showLabels className={classes.footerNav}>
              {menuItems.map((item, index) => (
                <BottomNavigationAction
                  key={index}
                  label={pathname.endsWith(item.route) ? item.name : ''}
                  icon={pathname.endsWith(item.route) ? item.filledIcon : item.outlinedIcon}
                  sx={{
                    height: '100%',
                    '& .MuiBottomNavigationAction-label': {
                      fontSize: '12px',
                      fontWeight: '500',
                      width: pathname.endsWith(item.route) ? '200px' : 'auto',
                      color: pathname.endsWith(item.route) ? '#604797' : '#8A8A8A', // Purple for selected label, gray for others
                    },
                    '& .MuiSvgIcon-root': {
                      color: pathname.endsWith(item.route) ? '#604797' : '#8A8A8A', // Purple for selected icon, gray for others
                    },
                    '&.Mui-selected': {
                      color: '#604797', // Ensures both icon and text are purple when selected
                    },
                  }}
                />
              ))}
            </BottomNavigation>
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              height: '100vh',
              width: '100vw',
              backgroundColor: '#F6F8FB',
            }}
          >
            <Grid container className={classes.mainContainer}>
              <Grid
                item
                xs={hideSideBar ? 1 : 2}
                sm={hideSideBar ? 0.5 : 2}
                md={hideSideBar ? 0.7 : 2}
                lg={hideSideBar ? 0.8 : 2}
                xl={hideSideBar ? 0.8 : 2}
                xxl={hideSideBar ? 0.6 : 2}
                fullHD={hideSideBar ? 0.5 : 2}
                ultraHD={hideSideBar ? 0.4 : 2}
                className={`sidebar scrollbar-cus ${hideSideBar ? 'sidebar-collapsed' : 'sidebar-expanded'}`}
              >
                <Paper className={`${classes.sideBarContainer}`}>
                  <Box className={classes.logoContainer}>
                    {!hideSideBar && (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: '6px', ultraHD: '8px' }, userSelect: 'none' }}>
                        <img src={Image.Images.kennovateLogo2} alt="logo" className={classes.logo} onClick={() => navigate(routes.home)} />
                        <Typography className={classes.logoTitle} sx={{ color: '#E6E6E6' }}>
                          Kennovate
                        </Typography>
                      </Box>
                    )}
                    <Box>
                      <IconButton
                        onClick={() => {
                          if (!isMobile) {
                            setHideSideBar(!hideSideBar);
                          }
                        }}
                      >
                        {hideSideBar ? <KeyboardDoubleArrowRightIcon className={classes.sideBarIcon} /> : <KeyboardDoubleArrowLeftIcon className={classes.sideBarIcon} />}
                      </IconButton>
                    </Box>
                  </Box>
                  <Box className={`${classes.sideBarSubContainer} scrollbar-cus`}>
                    <Box className={`${classes.sideBarSubContainer1} scrollbar-cus`}>
                      <SideNavTabs handleListClick={handleListClick} hideSideBar={hideSideBar} />
                    </Box>
                    <Box sx={{ mb: '24px' }}>
                      <ListItemButton
                        className={classes.listItemButton}
                        onClick={() => {
                          dispatch({ type: 'LOGOUT' });
                          navigate(routes.login);
                          window.location.reload();
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: { xs: '2px', lg: '40px' } }}>
                          <LogoutIcon className={classes.listItemIcon} />
                        </ListItemIcon>
                        {!hideSideBar && (
                          <ListItemText
                            className={classes.listItemText}
                            sx={{
                              display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                            }}
                          >
                            Logout
                          </ListItemText>
                        )}
                      </ListItemButton>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid
                item
                xs={hideSideBar ? 11 : 10}
                sm={hideSideBar ? 11.5 : 10}
                md={hideSideBar ? 11.3 : 10}
                lg={hideSideBar ? 11.2 : 10}
                xl={hideSideBar ? 11.2 : 10}
                xxl={hideSideBar ? 11.4 : 10}
                fullHD={hideSideBar ? 11.5 : 10}
                ultraHD={hideSideBar ? 11.6 : 10}
                className={`sidebar`}
              >
                <Box className={classes.headerContainer}>
                  <Box>
                    <Paper className={classes.header} sx={{ borderRadius: '16px !important', background: '#f5f8fb' }}>
                      {hideSideBar && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: '6px', ultraHD: '8px' }, userSelect: 'none' }}>
                          <img src={Image.Images.kennovateLogo} alt="logo" className={classes.logo} onClick={() => navigate(routes.home)} />
                          <Typography className={classes.logoTitle} sx={{ color: '#604797' }}>
                            Kennovate
                          </Typography>
                        </Box>
                      )}
                      <Box>
                        <AppBreadCrumbs />
                      </Box>
                    </Paper>
                  </Box>
                  <Box>
                    <Paper className={classes.actions}>
                      <Tooltip title="Notifications">
                        <IconButton sx={{ marginRight: { xs: '1px', lg: '10px', xl: '2px' } }} onClick={handleOpenClickOpenNotification}>
                          <NotificationsNoneOutlinedIcon sx={{ fontSize: { md: '18px', xl: '18px', xxl: '18px', fullHD: '18px', ultraHD: '24px' } }} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Profile">
                        <IconButton sx={{ p: '0' }} onClick={HandleAccount}>
                          <KenAvatar classes={classes.avatar} src={userData?.contactImage ? userData?.contactImage : Image.Images.DefaultProfileImage} />
                        </IconButton>
                      </Tooltip>
                      <Typography className={classes.actionText}>{userData.applicantName}</Typography>
                    </Paper>
                  </Box>
                </Box>
                <Divider sx={{ mx: { xs: '18px', ultraHD: '20px' }, color: '#F0EDF6' }} />
                <Box className={`${classes.childrenContainer} scrollbar-hide`}>{children}</Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {openNotification && <NotificationDialog open={openNotification} handleClose={handleCloseNotificationDialog} />}
    </>
  );
};

export default AppLayout;
